<template>
  <div class="mt-1">
    <p class="last-sending">{{ lastLabel }}</p>
    <b-table
      :busy="isLoading"
      head-variant="light"
      :items="items"
      :fields="fields"
      no-border-collapse
      responsive
      show-empty
      small
    >
      <template #table-busy>
        <table-skeleton />
      </template>
      <template #empty>
        <empty-table :isTableInModal="true" />
      </template>
      <template #cell(actions)="{ item }">
        <div class="action-buttons">
          <b-button
            v-if="
              hasSendingLog(item) &&
              canSeeProcedure(item.communication_procedure)
            "
            size="sm"
            variant="lisaweb"
            @click="onViewLogs(item)"
            title="Vedi log"
          >
            <b-icon icon="journal-text"></b-icon>
          </b-button>
        </div>
      </template>
      <template #cell(communication_procedure)="{ value }">
        <router-link
          v-if="canSeeProcedure(value)"
          :to="{
            name: 'communication_procedures.index',
            query: { id: value.id },
          }"
          title="Apri la procedura"
          >{{ procedureLabel(value) }}</router-link
        >
        <span v-else>{{ procedureLabel(value) }}</span>
      </template>
      <template #cell(status)="{ value }">
        <status-badge kind="sending" :status="value" />
      </template>
      <template #cell(error_message)="{ value }">
        <span :title="value">{{ value }}</span>
      </template>
      <template #cell()="{ value }">
        <span>{{ value }}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
// Scheda "Invii" della modale dei dettagli di quietanze e titoli:
// <sendings repository="insurance_payment" :resourceId="id" />
import StatusBadge from "@/components/StatusBadge";
import EmptyTable from "@/components/EmptyTable.vue";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { canSeeAllCommunications, canVerb } from "@/utils/permissions";
import {
  formatSentAt,
  hasSendingLog,
  lastSuccessfulLabel,
  sendingRows,
} from "@/utils/sendings";

export default {
  name: "Sendings",
  inheritAttrs: false, // dbRowData della modale: non serve e non va sul div
  props: {
    resourceId: Number,
    repository: { type: String, required: true },
  },
  components: {
    StatusBadge,
    EmptyTable,
  },
  data() {
    return {
      isLoading: false,
      items: [],
      fields: [
        {
          key: "actions",
          label: "",
          thClass: "align-middle actions-head",
          tdClass: "actions",
        },
        { key: "sent_at", label: "Data", formatter: formatSentAt },
        { key: "communication_procedure", label: "Procedura" },
        {
          key: "communication_procedure.user.formatted_title",
          label: "Effettuato da",
          formatter: (value) => value || "-",
        },
        { key: "channel.text", label: "Canale" },
        { key: "recipient", label: "Recapito" },
        { key: "status", label: "Esito" },
        {
          key: "error_message",
          label: "Messaggio di errore",
          formatter: (value) => value || "-",
        },
      ],
    };
  },
  computed: {
    lastLabel() {
      return this.isLoading ? "" : lastSuccessfulLabel(this.items);
    },
  },
  methods: {
    hasSendingLog,
    // Gli invii li vedono tutti; la procedura e i suoi log solo chi l'ha
    // creata, l'admin o chi può vedere quelle di tutti (link alla procedura
    // e "Vedi log").
    canSeeProcedure(procedure) {
      if (!procedure?.id || !canVerb("communication_procedures", "index"))
        return false;
      return (
        canSeeAllCommunications() ||
        Number(procedure.user_id) === Number(this.$store.state.auth.user?.id)
      );
    },
    procedureLabel(procedure) {
      if (!procedure) return "-";
      return `#${procedure.id} ${procedure.description || ""}`.trim();
    },
    onViewLogs(item) {
      this.$router.push({
        name: "lisacomunica_log",
        query: { procedure_id: item.communication_procedure.id },
      });
    },
    fetch() {
      this.isLoading = true;
      RepositoryFactory.get(this.repository)
        .sendings(this.resourceId)
        .then((response) => {
          this.items = sendingRows(response.data);
        })
        .catch((error) => {
          this.items = [];
          this.$showSnackbar({
            preset: "error",
            text: `${this.$getErrorMessage(error)}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    resourceId() {
      this.fetch();
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
